import { PropertiesStore } from '@hortplus/properties-react';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useStores } from '../stores/useStores';
import TrapModalContent from './TrapModalContent';

function EditTrapModal(props) {
  const { traplogStore } = useStores();
  const trappingZone = traplogStore.trappingZones.find(
    (trappingZone) => trappingZone.id === props.trap.trapping_zone_id
  );
  const [trapCoords, setTrapCoords] = useState(props.trap.location ? {
    lat: props.trap.location.coordinates[1],
    lng: props.trap.location.coordinates[0],
    valid: true, // Should always be valid initially.
    currentZone: trappingZone.name
  } : null);

  const hide = () => props.setTrapId(null);

  if (!props.trap) return null;
  else
    return (
      <Modal backdrop='static' show onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Trap</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              // react-select values
              trappingZone: {
                value: trappingZone.id,
                label: trappingZone.name
              },
              trapLure: {
                value: props.trap.trap_lure.id,
                label: props.trap.trap_lure.name
              },

              // Regular inputs
              code: props.trap.code,
              name: props.trap.name,
              location_description: props.trap.location_description,
              comments: props.trap.comments === null ? '' : props.trap.comments,
              setup_at: moment(props.trap.setup_at).format('YYYY-MM-DD'),
              charged_at: props.trap.charged_at ? moment(props.trap.charged_at).format('YYYY-MM-DD') : null
            }}
            validate={(values) => {
              const errors = {};

              if (!values.trappingZone) errors.trappingZone = 'Required';
              if (!values.code) errors.code = 'Required';
              if (!values.trapLure) errors.trapLure = 'Required';

              return errors;
            }}
            onSubmit={(values, actions) => {
              fetch(
                `${process.env.REACT_APP_TRAPLOG_API_URL}api/traps/${props.trap.id}?with[]=trapLure.insects`,
                {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${props.bearerToken}`,
                    SeasonalDatabase: props.selectedDatabase
                  },
                  body: JSON.stringify({
                    trapping_zone_id: values.trappingZone.value,
                    code: values.code,
                    name: values.name,
                    location_description: values.location_description,
                    lat: trapCoords?.lat,
                    lon: trapCoords?.lng,
                    trap_lure_id: values.trapLure.value,
                    comments: values.comments,
                    setup_at: `${values.setup_at}T00:00:00`,
                    charged_at: values.charged_at ? `${values.charged_at}T00:00:00` : null
                  })
                }
              )
                .then((res) => {
                  if (res.ok) {
                    traplogStore.updateTrappingZones(
                      props.propertiesStore.selectedPropertyId
                    )
                  }
                  else if (res.status === 401) props.refreshBearerToken();
                  else throw Error(res.statusText);
                })
                .catch((err) => {
                  if (process.env.NODE_ENV === 'development')
                    console.error(err);
                })
                .finally(() => {
                  actions.setSubmitting(false);
                  hide();
                });
            }}
          >
            {(fProps) => (
              <TrapModalContent 
                selectedDatabase={props.selectedDatabase}
                bearerToken={props.bearerToken}
                refreshBearerToken={props.refreshBearerToken}
                type="edit"
                fProps={fProps}
                trapCoords={trapCoords}
                setTrapCoords={setTrapCoords}
                map={props.map}
                chargedInput={props.chargedInput}
              />
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    );
}

EditTrapModal.propTypes = {
  selectedDatabase: PropTypes.string.isRequired,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired,
  trap: PropTypes.object.isRequired,
  setTrapId: PropTypes.func.isRequired
};

export default observer(EditTrapModal);
